import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'customer-app-fv-right',
  templateUrl: './fv-right.component.html',
  styleUrls: ['./fv-right.component.scss'],
  standalone: false
})
export class FvRightComponent {
  @Input() image: string;
  @Input() text: { headline: string; text: string };
  readonly needsColumn = input(false);
  readonly maxHeight = input('calc(100vh - 210px)');
  readonly imageMaxWidth = input('350px');
}
